import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { selectUser } from 'library/redux/application';
import { useAppSelector } from 'library/redux/hooks';
import { ErrorContent } from 'main/errors/ErrorContent';
import QaAccessForm from 'modules/QaAccess/QaAccessForm';

const ErrorUnauthorizedPage = (): React.JSX.Element => {
	const { t } = useTranslation('error');

	const dbUser = useAppSelector(selectUser);

	const userNotInDb = dbUser.userId == null;

	const isQaAccessSystemOn = () =>
		import.meta.env.VITE_IS_QA_ACCESS_SYSTEM_ENABLED === 'true';

	const displayQaAccessForm = isQaAccessSystemOn() && userNotInDb;

	return (
		<Box>
			<ErrorContent
				description={
					isQaAccessSystemOn() ? undefined : t('contact-support')
				}
				subtitle={t('unauthorized-subtitle')}
				title={t('unauthorized-title')}
				displayHomeButton={!displayQaAccessForm}
			/>
			{displayQaAccessForm && <QaAccessForm />}
		</Box>
	);
};

export default ErrorUnauthorizedPage;
